import { render, staticRenderFns } from "./UserArchives.vue?vue&type=template&id=07718633&scoped=true&"
import script from "./UserArchives.vue?vue&type=script&lang=ts&"
export * from "./UserArchives.vue?vue&type=script&lang=ts&"
import style0 from "./UserArchives.vue?vue&type=style&index=0&id=07718633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07718633",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
